<template>
  <div
    class="iowa-dot-component-container"
    :class="{mastery}"
  >
    <label class="title">Have a valid Iowa driver's license? (Optional)</label>
    <label class="secondary">Date of birth</label>
    <div class="dob">
      <input
        v-model="month"
        aria-label="Month input"
        type="text"
        maxlength="2"
        placeholder="MM"
        @input="change()"
      >
      <input
        v-model="day"
        aria-label="Day input"
        type="text"
        maxlength="2"
        placeholder="DD"
        @input="change()"
      >
      <input
        v-model="year"
        aria-label="Year input"
        type="text"
        maxlength="4"
        placeholder="YYYY"
        @input="change()"
      >
    </div>
    <label class="secondary">Last 4 digits of driver's license</label>
    <input
      v-model="dln"
      aria-label="Last 4 driver's license input"
      type="text"
      maxlength="4"
      placeholder="XXXX"
      @input="change()"
    >
    <div class="label">
      OR
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activator: {
      type: Object,
      default: () => ({}),
    },
    mastery: {
      type: Boolean,
    },
  },
  data() {
    return {
      month: null,
      day: null,
      year: null,
      dln: null,
    };
  },
  computed: {
    dob() {
      return `${this.month}/${this.day}/${this.year}`;
    },
    valid() {
      return this.month?.length === 2 && this.day?.length === 2 && this.year?.length === 4 && this.dln?.length === 4;
    },
  },
  methods: {
    change() {
      let params = {
        id: this.activator.id,
      };

      if (this.valid) {
        params.data = {
          dob: this.dob,
          dln: this.dln,
        };
      }

      this.$eventBus.$emit('activation-code-change', params);
    },
  },
};
</script>
<style lang='scss' scoped>
.iowa-dot-component-container {
  margin-top: rem-calc(4);

  input {
    border: 1px solid #dfe3e9;
    border-radius: 4px;
    box-sizing: border-box;
    color: #7f8fa4;
    font-size: rem-calc(14);
    margin: rem-calc(4) 0;
    max-width: 70px;
    padding: rem-calc(8);
    width: 100%;

    @include focus-not-visible {
      outline: none !important;
    }
  }

  .dob input {
    width: 70px;
  }

  label.secondary {
    display: block;
    font-size: rem-calc(12);
    font-weight: $semi-bold;
    margin-top: rem-calc(8);
  }

  .label {
    font-size: rem-calc(18);
    font-weight: $bold;
    margin: rem-calc(8) 0;
    text-align: center;
  }

  &.mastery {
    text-align: left;

    input {
      border: 1px solid #001c74;
      border-radius: 1px;

      &::placeholder {
        color: #8698cc;
      }
    }
  }
}
</style>
